/** Construcción de los query-params de la pantalla de Cambios.
 *
 * Extraído de ChangesPage para poder testearlo: estas reglas deciden QUÉ ve el
 * usuario en la lista y QUÉ se descarga en el Excel (la lista y la exportación
 * comparten esta función, §77). Un bug aquí = el cliente ve o exporta datos
 * equivocados.
 */
export type ChangeFilters = {
  change_type: string;
  tag: string;            // "" | "itf" | "competidor" | "otros" | "mercado"
  search: string;
  priority: string;
  date: string;           // día concreto (YYYY-MM-DD) — gana sobre from/to
  from_date: string;
  to_date: string;
  laboratory: string;     // filtro exacto por laboratorio (reusa el buscador)
  marked: string;
  // Filtros por hito (R-11, §89). Opcionales: los llamadores antiguos no los traen.
  hito_group?: string;    // "1".."11"
  hito_id?: string;       // "FI-04"
  severity?: string;      // "A" | "D" | "I"
  consolidated?: boolean; // C-14: una fila por hecho, confirmaciones dentro (§90 Fase 1C)
  source?: string;        // código de fuente (Anexo II-A 4.4: filtro por fuente)
  atc?: string;           // prefijo ATC (barras del Dashboard)
};

export function buildChangeParams(filters: ChangeFilters, isSuperAdmin: boolean): URLSearchParams {
  const params = new URLSearchParams();
  if (filters.change_type) params.set("change_type", filters.change_type);

  if (filters.tag === "itf") params.set("is_portfolio", "true");
  else if (filters.tag === "competidor") params.set("is_competitor", "true");
  else if (filters.tag === "otros") {
    params.set("is_portfolio", "false");
    params.set("is_competitor", "false");
  }
  // Vista por defecto de un usuario de org: sólo su portfolio + competencia.
  // "mercado" (Todo el mercado) no envía scope → comportamiento global.
  else if (filters.tag !== "mercado" && !isSuperAdmin) params.set("scope", "org");

  if (filters.search) params.set("search", filters.search);
  // El filtro por laboratorio reusa el buscador del backend; va DESPUÉS a
  // propósito: si hay laboratorio, manda sobre el texto de búsqueda libre.
  if (filters.laboratory) params.set("search", filters.laboratory);
  if (filters.priority) params.set("priority", filters.priority);
  if (filters.marked) params.set("marked", filters.marked);
  if (filters.hito_group) params.set("hito_group", filters.hito_group);
  if (filters.hito_id) params.set("hito_id", filters.hito_id);
  if (filters.severity) params.set("severity", filters.severity);
  if (filters.consolidated) params.set("consolidated", "1");
  if (filters.source) params.set("source", filters.source);
  if (filters.atc) params.set("atc", filters.atc);

  if (filters.date) {
    params.set("from_date", `${filters.date}T00:00:00`);
    params.set("to_date", `${filters.date}T23:59:59`);
  } else {
    if (filters.from_date) params.set("from_date", filters.from_date);
    if (filters.to_date) params.set("to_date", filters.to_date);
  }
  return params;
}
